import classNames from "classnames";
import CompareIcon from "PFIcons/compare.svg";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./add_to_comparision_button.less";

const AddToComparisonButton = ({ isItemInComparision, removeItemFromComparison, addItemToComparison }) => {
  const { t } = useTranslation("activities");

  return (
    <button
      onClick={isItemInComparision ? removeItemFromComparison : addItemToComparison}
      className={classNames(css.compare, { [css.compared]: isItemInComparision })}
      title={t("show.parts.addToComparison")}
    >
      <CompareIcon height={20} width={20} />
    </button>
  );
};

AddToComparisonButton.propTypes = {
  isItemInComparision: PropTypes.bool.isRequired,
  removeItemFromComparison: PropTypes.func.isRequired,
  addItemToComparison: PropTypes.func.isRequired
};

export default AddToComparisonButton;
